import { render, staticRenderFns } from "./TabComposizione.vue?vue&type=template&id=7caf9cb9&scoped=true&"
import script from "./TabComposizione.vue?vue&type=script&lang=js&"
export * from "./TabComposizione.vue?vue&type=script&lang=js&"
import style0 from "./TabComposizione.vue?vue&type=style&index=0&id=7caf9cb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caf9cb9",
  null
  
)

export default component.exports